var MessagingSummaryRequest = /** @class */ (function () {
    function MessagingSummaryRequest() {
        this.Action = 'getmessagingsummary';
    }
    return MessagingSummaryRequest;
}());
export { MessagingSummaryRequest };
